<template>
  <div data-v-e928e504="" data-v-2ac6a5fc="" class="home-page login-bar-stance">
    <div id="redPacket" v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow">
      <i class="grab" @click="$parent.goNav('/hongbao')"></i>
      <img @click="changhongbashow" src="/static/image/close_popup.png" />
    </div>
    <div style="position: fixed; top: 0; left: 0; z-index: 999; width: 100vw; height: 100vh; background: rgb(0 0 0 / 66%)" data-v-a691d594="" data-v-710c460e="" data-v-29c11a50="" class="popup-background" v-if="tanshow && $store.state.appInfo.index_modal == 1 && shouldShow()">
      <div data-v-a691d594="" data-v-29c11a50="" data-v-710c460e="" class="safety-tip" style="top:35%;width: 90% !important; position: relative;background-color: rgb(20, 20, 20,0);padding: 0px;">
        <i
          data-v-a691d594=""
          data-v-29c11a50=""
          data-v-710c460e=""
          @click="changtanshow"
          style="
            position: absolute;
            bottom: -50px;
            left: calc((100% - 18px) / 2);
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAABL0lEQVRIx63WuW7DMAyA4V/yA6ZLayCJu/KZtDZors0PaKSD6cBAbYk6NNo0v5DR5QBCCB3wA4wi8qThCCF8Ah/At4hMTrFfoAcm4NgKDSF8AVegAx7AyWtlvcZ0wFUDW2KocfHAqJUtoxrdwFBjdImA7PZGcp1E5OEMgWY0hQH45akmPe60t2+BAbjSD0u/cbUJcn/gJmhNVNKNXTCVEHjlYkkwgZKLmcAIuh4mzAwmUDMGq3VoGK/Cd/mgVndju6VZe2/rSZPcBqMVRrAz89LIPmVKFv5ZRO4a0zMf3uZKc7e2N7aKzUJ9DQagy2Gvvf9OGVeDGSvdPp5KNuISNHXFMGNW1LXELKhnvqQ2wyA6kQ4eGIBl+lZjEfQJDMt/2AEX5qt+NbbR3gMwiMj0B1Z0CwG5IivjAAAAAElFTkSuQmCC);
            width: 18px;
            height: 18px;
            background-size: 100% 100%;
          "
        ></i>
        <div style="position: absolute;text-align: center;width: 100%;bottom: -25px;color: #eee;"><input type="checkbox" v-model="isTokenChecked" /> <span>今日不再显示</span></div>
        <div data-v-a691d594="" data-v-29c11a50="" data-v-710c460e="" class="title">欢迎来到{{ $store.state.appInfo.title }}</div>
        <div data-v-a691d594="" data-v-29c11a50="" data-v-710c460e="" class="unbind-box" v-html="$store.state.appInfo.webcontent"></div>
      </div>
    </div>
    <div data-v-26f3bfed="" data-v-e928e504="" class="banner">
      <van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false" v-if="bannerList && bannerList.length > 0">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <div data-v-26f3bfed="" style="width: 100%; padding: 10px">
            <img data-v-26f3bfed="" :src="item.src" alt="" class="banner-img" style="border-radius: 8px" />
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div data-v-e928e504="" class="main">
      <div data-v-e928e504="" class="block" style="padding: 0px">
        <van-notice-bar left-icon="volume-o" :scrollable="true" :background="'#282828'" color="#C2BBC6" v-if="homenoticelis && homenoticelis.length > 0">
          <template #left-icon>
            <van-icon name="volume-o" :color="'#cca352'" size="20" style="margin-right: 8px" />
          </template>
          <template>
            <span v-for="(item, index) in homenoticelis" :key="index">{{ removeHtmlTags(item.content) }}</span>
          </template>
          <template #right-icon>
            <van-button color="#cca352" round style="height: 20px !important; padding: 2px 6px !important; margin-left: 8px" @click="$router.push({ path: 'activeList' })"><van-icon name="fire-o" />热门活动</van-button>
          </template>
        </van-notice-bar>
        <div data-v-4335771e="" data-v-e928e504="" class="game-list">
          <div data-v-4335771e="" class="table-block" style="overflow: hidden">
            <van-row style="width: 100%" v-if="!$store.state.token">
              <van-col :span="10">
                <van-button color="#cca352" plain style="width: 95%; margin: 0 auto; border-radius: 8px; background-color: #282828 !important" @click="$router.push({ path: 'login' })"><span style="font-size: 20px">登录</span></van-button>
              </van-col>
              <van-col :span="14">
                <van-button color="#cca352" style="width: 95%; margin: 0 auto; float: right; margin-right: 10px; border-radius: 8px; position: relative" @click="$router.push({ path: 'register' })">
                  <span style="font-size: 20px">立即注册</span>
                  <img src="/static/image/JEA00000387814087.gif" style="height: 46px; width: 56px; position: absolute; top: 0px; right: 0px; border-top-right-radius: 8px; border-bottom-right-radius: 8px" />
                </van-button>
              </van-col>
            </van-row>
            <van-row v-else>
              <van-col :span="10">
                <div style="float: left; height: 54px; width: 54px">
                  <img data-v-68894370="" style="height: 100%; width: 100%; border-radius: 50%" :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/img1.2ceab29b.png'" />
                </div>
                <div style="margin-left: 8px; float: left; padding-top: 4px">
                  <p style="font-size: 18px; color: #fff">{{ $store.state.userInfo.username }}</p>
                  <span style="font-weight: 600; font-size: 24px; color: #fff">{{ $store.state.userInfo.balance }}</span>
                </div>
              </van-col>
              <van-col :span="14">
                <ul style="margin-top: 4px">
                  <li style="position: relative; float: right; text-align: center; width: 50px; line-height: 0.9; color: #fff" @click="$parent.goNav('/myNews')">
                    <div v-if="noticeList && noticeList.filter(e=>e.is_read != 1).length > 0" style="border-radius: 50%; position: absolute; font-size: 10px; text-align: center; line-height: 13px; top: 0px; right: 8px; background-color: red; color: #fff; width: 15px; height: 15px">{{ noticeList.filter(e=>e.is_read != 1).length }}</div>
                    <img src="/static/image/user/2.png" style="height: 35px; width: 35px" />
                    <p>消息</p>
                  </li>
                  <li style="float: right; text-align: center; width: 50px; line-height: 0.9; color: #fff" @click="$parent.goNav('/assets')">
                    <img src="/static/image/user/3.png" style="height: 35px; width: 35px" />
                    <p>转账</p>
                  </li>
                  <li style="float: right; text-align: center; width: 50px; line-height: 0.9; color: #fff" @click="$parent.goNav('/withdraw')">
                    <img src="/static/image/user/4.png" style="height: 35px; width: 35px" />
                    <p>提现</p>
                  </li>
                  <li style="float: right; text-align: center; width: 50px; line-height: 0.9; color: #fff" @click="$parent.goNav('/deposit')">
                    <img src="/static/image/user/1.png" style="height: 35px; width: 35px" />
                    <p>充值</p>
                  </li>
                </ul>
              </van-col>
            </van-row>
          </div>
        </div>
        <van-sticky :offset-top="50">
          <van-tabs v-model="active" color="#282828" title-active-color="#282828" title-inactive-color="#fff" background="#282828" class="home-tab">
            <van-tab v-for="(item, index) in tabs" :key="index" :name="item.id">
              <template #title>
                <div :class="active == item.id ? 'ac' : 'noac'" @click="tabClick(item)">
                  <div style="float: left"><img :src="item.game_img" style="width: 19px; height: 19px; margin-top: 5px" />&nbsp;</div>
                  <div style="float: left">
                    {{ item.name }}
                  </div>
                </div>
              </template>
            </van-tab>
          </van-tabs>
        </van-sticky>
        <div v-show="active == '-1'" class="home-hot-box" v-if="hotData">
          <div v-if="hotData.filter(e => e.id == 1) && hotData.filter(e => e.id == 1).length > 0">
            <div style="font-size: 18px; font-weight: 600; margin: 10px 0 10px 15px; color: #fff; position: relative">
              {{ hotData.filter(e => e.id == 1)[0].title }}
              <div class="jiangjinchi" @click="$parent.goNav('/games')">
                <p style="margin-left: 20px; float: left; background: linear-gradient(90deg, #fff9c0, #ffb951); background-clip: text; -webkit-background-clip: text; -webkit-text-fill-color: transparent">JACKPOT奖池</p>
                <div style="float: right; margin-right: 4px">
                  <div style="float: left" v-for="item in 8" :key="item">
                    <van-swipe :ref="'jjc_' + item" style="width: 15px; height: 20px" vertical>
                      <van-swipe-item v-for="item in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]" :key="item">{{ item }}</van-swipe-item>
                      <template #indicator>
                        <div style="display: none"></div>
                      </template>
                    </van-swipe>
                  </div>
                  <div style="float: left"><van-icon name="arrow" /></div>
                </div>
              </div>
            </div>
            <div style="margin: 10px 10px">
              <van-grid :border="false">
                <van-grid-item v-for="(item, index) in hotData.filter(e => e.id == 1)[0].items" :key="index">
                  <div v-if="item.type == 'game'" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.supplier)" style="text-align: center; position: relative">
                    <div v-if="item.desc_mark && item.desc_mark.length > 0" style="position: absolute; top: 0px; left: 0px; color: #fff; padding: 3px 5px; font-size: 12px; border-top-left-radius: 10px" :style="'background:' + item.mark_color">
                      {{ item.desc_mark }}
                    </div>
                    <div style="width: 100%">
                      <img data-v-5648ec66="" :src="item.game_img" lazy="loaded" style="width: 100%; border-radius: 8px" />
                    </div>
                    <div style="width: calc(100vw / 4 - 25px); margin-top: 2px; font-size: 13px; margin-bottom: 2px; color: #c2bbc6; white-space: nowrap; overflow: hidden">{{ item.name }}</div>
                  </div>
                  <div v-if="item.type == 'category'" @click="$parent.goNavParam('/games', { pyid: item.id })" style="text-align: center">
                    <div style="width: 100%">
                      <img data-v-5648ec66="" :src="item.game_img" lazy="loaded" style="width: 100%; border-radius: 8px" />
                    </div>
                    <div style="width: calc(100vw / 4 - 30px); margin-top: 2px; font-size: 14px; margin-bottom: 2px; color: #c2bbc6; white-space: nowrap; overflow: hidden">{{ item.name }}</div>
                  </div>
                </van-grid-item>
              </van-grid>
              <div style="background-color: #141414; text-align: center; padding: 10px; margin: 10px 14px; border-radius: 10px">
                <p style="font-size: 16px; font-weight: 700; color: #cca352; line-height: 1.6" @click="$parent.goNav('/games')">前往游戏大厅</p>
                <span style="color: #c2bbc6">查看全部游戏</span>
              </div>
            </div>
          </div>
          <div v-if="hotData.filter(e => e.id == 2) && hotData.filter(e => e.id == 2).length > 0">
            <div style="font-size: 18px; font-weight: 600; margin: 20px 0 10px 15px; color: #fff; position: relative">
              {{ hotData.filter(e => e.id == 2)[0].title }}
              <div style="position: absolute; font-size: 14px; color: #c2bbc6; right: 10px; top: 2px; display: none">查看详情<van-icon name="arrow" /></div>
            </div>
            <div>
              <van-swipe class="my-swipe" autoplay="4000">
                <van-swipe-item v-for="(item, index) in hotData.filter(e => e.id == 2)[0].items" :key="index">
                  <div>
                    <div v-if="item.type == 'game'" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.supplier)" style="padding: 10px">
                      <div :style="'background-image: url(/static/image/shixunbg/'+(index % 5)+'.png);'" style=" background-repeat: no-repeat; background-size: 100% 100%; border-radius: 10px; position: relative; width: calc(100vw - 20px); height: calc((100vw - 20px) / 5 * 2)">
                        <div style="position: absolute; right: 10px; top: 10px; width: 140px; height: calc((100vw - 20px) / 3)">
                          <img style="width: auto; height: 100%; " data-v-4335771e="" :src="item.game_img" lazy="loaded" />
                        </div>
                        <div style="position: absolute; top: 20px; left: 20px; font-weight: 700; font-size: 24px; color: #fff; width: calc(100vw - 20px); line-height: 2">
                          <p style="font-size: 24px; font-weight: 600; color: #fff; margin-top: 10px; margin-left: 5px">{{ item.name }}</p>
                          <p style="margin-left: 5px; font-size: 16px; color: #fff">{{ item.category_en }}</p>
                          <p style="margin-left: 5px; font-size: 16px; color: #fff">{{ item.desc_num }} {{ item.desc_unit }}</p>
                          <div style="margin-left: 5px; color: #fff; font-size: 16px">
                            高达<span style="color: #cca352; margin: 0 8px">{{ item.betrayal }}</span>
                            <a href="javascript:void(0);" style="background-color: #cca352; color: #fff; padding: 2px 5px; border-radius: 5px">{{ item.home_desc }}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="width: calc(100vw - 20px); height: calc((100vw - 20px) / 4 * 2); margin: 0 auto; position: relative" v-if="item.type == 'category'" @click="$parent.goNavParam('/games', { pyid: item.id })">
                      <img style="border-radius: 8px; width: 100%; height: 100%; object-fit: cover" data-v-4335771e="" :src="item.game_img" lazy="loaded" />
                      <div style="text-align: center; position: absolute; bottom: 20px; left: 15px; font-weight: 700; font-size: 24px; color: #fff; width: calc(100vw - 20px)">{{ item.name }}</div>
                    </div>
                  </div>
                </van-swipe-item>
                <template #indicator>
                  <div></div>
                </template>
              </van-swipe>
            </div>
          </div>
          <div v-if="hotData.filter(e => e.id == 3) && hotData.filter(e => e.id == 3).length > 0">
            <div style="font-size: 18px; font-weight: 600; margin: 20px 0 10px 15px; color: #fff; position: relative">
              {{ hotData.filter(e => e.id == 3)[0].title }}
            </div>
            <div style="margin: 0 10px">
              <van-row>
                <van-col :span="12" v-for="(item, index) in hotData.filter(e => e.id == 3)[0].items" :key="index" style="text-align: center">
                  <div style="padding: 3px">
                    <div style="background-color: rgb(20, 20, 20); border-radius: 8px; padding: 10px; height: calc((100vw - 30px) / 4); position: relative">
                      <div v-if="item.type == 'game'" style="width: calc((100vw - 30px) / 3); height: calc((100vw - 30px) / 3)" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.supplier)">
                        <img data-v-5648ec66="" :src="item.game_img" lazy="loaded" style="width: 100%; height: 100%; border-radius: 8px" />
                      </div>
                      <div v-if="item.type == 'category'" @click="$parent.goNavParam('/games', { pyid: item.id })">
                        <div style="z-index: 9; position: absolute; text-align: center; top: 0px; left: 5px;width: 100%;">
                          <div style="width: 50%;">
                            <p style="font-size: 14px; font-weight: 600; color: #fff; margin-top: 35px;">{{ item.name }}</p>
                            <p style="font-size: 12px; color: #fff">{{ item.desc_num }} {{ item.desc_unit }}</p>
                            <div style="color: #fff">
                              高达<span style="color: #cca352; margin: 0 8px">{{ item.betrayal }}</span>
                              
                            </div>
                          </div>
                        </div>
                        <div style="width: calc((100vw - 30px) / 4); height: calc((100vw - 30px) / 4); position: absolute; right: 2px; top: 4px; z-index: 8">
                          <img data-v-5648ec66="" :src="item.game_img" lazy="loaded" style="width: 100%; height: 100%; border-radius: 8px" />
                        </div>
                        <a href="javascript:void(0);" style="background-color: #cca352; color: #fff; padding: 2px 5px; border-radius: 5px;position: absolute;
                        right: 10px; bottom: 10px; z-index: 9
                        ">{{ item.home_desc }}</a>
                      </div>
                    </div>
                  </div>
                </van-col>
              </van-row>
            </div>
          </div>
        </div>
        <div v-show="active != '-1'" style="padding: 10px 0">
          <div v-if="showgamelst && showgamelst.game_data">
            <div v-if="1 == 1">
              <div v-for="(item, index) in showgamelst.game_data" :key="index">
                <div
                  v-if="showgamelst.show_type == 1"
                  @click="$parent.goNavParam('/games', { pyid: item.id, type: showgamelst.game_id })"
                  style="background-image: url(/static/image/default.webp); height: 153px; position: relative; padding: 10px; border-radius: 10px; margin: 10px 15px; background-repeat: no-repeat; background-size: 100% 100%; background-position: center"
                >
                  <div style="line-height: 1.6">
                    <p style="font-size: 24px; font-weight: 600; color: #fff; margin-top: 35px; margin-left: 20px">{{ item.name }}</p>
                    <p style="margin-left: 20px; font-size: 18px; color: #fff">{{ item.desc_num }} {{ item.desc_unit }}</p>
                    <div style="margin-left: 20px; color: #fff">
                      高达<span style="color: #cca352; margin: 0 8px">{{ item.betrayal }}</span>
                      <a href="javascript:void(0);" style="background-color: #cca352; color: #fff; padding: 2px 5px; border-radius: 5px">{{ item.home_desc }}</a>
                    </div>
                  </div>
                  <div style="position: absolute; width: 154px; height: 154px; top: 0px; right: 8px">
                    <img :src="item.game_img" style="width: 100%; height: 100%; object-fit: cover" />
                  </div>
                </div>
                <div
                  v-if="showgamelst.show_type == 2"
                  @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.supplier)"
                  style="background-image: url(/static/image/default.webp); height: 153px; position: relative; padding: 10px; border-radius: 10px; margin: 10px 15px; background-repeat: no-repeat; background-size: 100% 100%; background-position: center"
                >
                  <div style="line-height: 1.6">
                    <p style="font-size: 24px; font-weight: 600; color: #fff; margin-top: 35px; margin-left: 20px">{{ item.name }}</p>
                    <p style="margin-left: 20px; font-size: 18px; color: #fff">{{ item.desc_num }} {{ item.desc_unit }}</p>
                    <div style="margin-left: 20px; color: #fff">
                      高达<span style="color: #cca352; margin: 0 8px">{{ item.betrayal }}</span>
                      <a href="javascript:void(0);" style="background-color: #cca352; color: #fff; padding: 2px 5px; border-radius: 5px">{{ item.home_desc }}</a>
                    </div>
                  </div>
                  <div style="position: absolute; width: 154px; height: 154px; top: 0px; right: 8px">
                    <img :src="item.game_img" style="width: 100%; height: 100%; object-fit: cover" />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="showgamelst.show_type == 2" class="home-game-box" style="display: none;">
              <van-grid :border="false">
                <van-grid-item v-for="(item, index) in showgamelst.game_data" :key="index">
                  <div @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.supplier)" style="text-align: center">
                    <div>
                      <img data-v-5648ec66="" :src="item.game_img" lazy="loaded" style="width: 100%; height: 100%; object-fit: cover; border-radius: 8px" />
                    </div>
                    <div style="width: calc(100vw / 4 - 30px); margin-top: 2px; font-size: 16px; margin-bottom: 2px; color: #c2bbc6; white-space: nowrap; overflow: hidden">{{ item.name }}</div>
                  </div>
                </van-grid-item>
              </van-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-64785503="" data-v-2ac6a5fc="" class="footerWrap login-bar-stance">
      <div data-v-64785503="" class="links" style="display: none">
        <span data-v-64785503=""><a @click="$parent.goNav('/faq')" style="color: #cca352">帮助中心</a></span>
        <span data-v-64785503="" class="br">|</span>
        <span data-v-64785503=""><a @click="$parent.goNav('/about')" style="color: #cca352">关于我们</a></span>
      </div>
      <p data-v-64785503="" class="copyright" style="display: none">© 2022 $store.state.appInfo.title. All Rights Reserved.</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data () {
    return {
      homenoticelis: [],
      homenoticelisstr: null,
      bannerList: [],
      realbetList: [],
      jokerList: [],
      gamingList: [],
      sportList: [],
      lotteryList: [],
      hongbashow: true,
      conciseList: [],
      tanshow: true,
      active: '-1',
      tabs: [],
      list: [],
      token: null,
      gamelst: [],
      showgamelst: null,
      hotData: [],
      timer: null,
      randomnum: null,
      noticeList: [],
      isTokenChecked: false,
    };
  },
  created () {
    let that = this;
    that.gametabs();
    // that.getGameList();
    that.homenotice();
    that.getBanList();
    that.getIndexData();
    if (that.$store.state.token) {
      that.getnoticeList();
    }
  },
  methods: {
    setTodayNotShow () {
      const today = new Date().toLocaleDateString();
      localStorage.setItem('dontShowToday', today);
    },

    shouldShow () {
      const lastHideDate = localStorage.getItem('dontShowToday');
      return lastHideDate !== new Date().toLocaleDateString();
    },
    getnoticeList () {
      let that = this;
      let page = that.page;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/noticeList', { page, limit: 999 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.noticeList = res.data.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    removeHtmlTags (htmlString) {
      if (htmlString && htmlString.length > 0) {
        return htmlString.replace(/<[^>]+>/g, '');
      }
      return '';
    },
    getIndexData () {
      let that = this;
      that.$apiFun.get('/api/hot_index', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.hotData = res.data;
        }
      });
    },
    tabClick (val) {
      if (val.id == -1) return;
      if (this.gamelst.filter(e => e.game_id == val.id).length > 0) {
        this.showgamelst = this.gamelst.filter(e => e.game_id == val.id)[0];
      } else {
        this.getgamebytab(val);
      }
    },
    getIcon (ptf, name) {
      var tmp = '';
      switch (ptf) {
        case 'realbet':
          tmp = '/static/image/realbet/' + name + '.jpg';
          break;
        case 'sport': //, name: '体育' },
          tmp = '/static/image/sport/' + name + 'ty.png';
          break;
        case 'concise': //, name: '电子' },
          tmp = '/static/image/concise/' + name + 'dz.png';
          break;
        case 'gaming': //, name: '电竞' },
          tmp = '/static/image/gaming/' + name + '.webp';
          break;
        case 'joker': //, name: '棋牌' },
          tmp = '/static/image/joker/' + name + 'qp.png';
          break;
        case 'lottery11': //, name: '彩票' },
          tmp = '/static/image/lottery/' + name + '.png';
          break;
        case 'slot': //, name: '老虎机' },
          tmp = '/static/image/realbet/' + name + '.jpg';
          break;
        case 'mini': //, name: '迷你游戏' },
          tmp = '/static/image/realbet/' + name + '.jpg';
          break;
        case 'casino11': //, name: '赌场' },
          tmp = '/static/image/realbet/' + name + '.jpg';
          break;
        default:
          tmp = '/static/image/default.webp';
          break;
      }
      return tmp;
    },
    changtanshow () {
      if(this.isTokenChecked){
        this.setTodayNotShow()
      }
      this.tanshow = !this.tanshow;
    },
    changhongbashow () {
      this.hongbashow = false;
    },
    getGameList () {
      let that = this;

      that.$apiFun.get('/api/game/list', { category: '' }).then(res => {
        if (res.code == 200) {
          this.list = res.data;
          this.list.forEach(el => {
            if (el.category_id == 'realbet') {
              that.realbetList.push(el);
            }
            if (el.category_id == 'joker') {
              that.jokerList.push(el);
            }
            if (el.category_id == 'gaming') {
              that.gamingList.push(el);
            }
            if (el.category_id == 'sport') {
              that.sportList.push(el);
            }
            if (el.category_id == 'lottery') {
              that.lotteryList.push(el);
            }
            if (el.category_id == 'concise') {
              that.conciseList.push(el);
            }
          });
        }
      });
    },
    homenotice () {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          that.homenoticelisstr = '';
          res.data.forEach(element => {
            that.homenoticelisstr += element + '  ';
          });
        }
      });
    },
    gametabs () {
      let that = this;
      that.$apiFun.get('/api/gameType', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.tabs = res.data;
          that.tabs.unshift({ name: '推荐', id: '-1', game_img: '/static/image/tabs/b5.webp' });
        }
      });
    },
    getgamebytab (item) {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/categoryEntry', { id: item.id })
        .then(res => {
          that.$parent.hideLoading();
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.gamelst.push({ game_id: item.id, game_data: res.data.list, show_type: item.show_type });
            that.showgamelst = this.gamelst.filter(e => e.game_id == item.id)[0];
          }
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getBanList () {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bannerList', { type: 2 })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.showTost(res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getnumData () {
      if (this.$refs['jjc_1']) {
        if (!this.randomnum) {
          this.randomnum = this.getRandomFloat(12432455, 26453903);
        } else {
          this.randomnum += this.getRandomFloat(50, 500);
        }
        const arr = String(this.randomnum).split('').map(Number);
        arr.forEach((item, index) => {
          if (this.$refs['jjc_' + (index + 1)] && this.$refs['jjc_' + (index + 1)].length > 0) {
            const tmpC = this.$refs['jjc_' + (index + 1)][0];
            if (tmpC) {
              tmpC.swipeTo(item);
            }
          }
        });
      }
    },
    getRandomFloat (min, max) {
      return Math.random() * (max - min) + min;
    },
  },
  mounted () {
    let that = this;
    this.token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;

    this.$nextTick(() => {
      that.timer = setInterval(() => {
        that.getnumData();
      }, 3000);
    });
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer);
  },
  updated () {
    let that = this;

    var mySwiper = new Swiper('.swiper', {
      slidesPerView: '1',
    });
    $(window).scroll(function () {
      if ($(document).scrollTop() <= 50) {
        $('.header-container').removeClass('headerBg');
        $('#headerBefore').css('height', '');
      } else {
        $('.header-container').addClass('headerBg');
        $('#headerBefore').css('height', '50px');
      }
    });
  },
};
</script>
<style>
.home-tab > .van-tabs__line {
  display: none !important;
}
.home-hot-box .van-grid-item__content,
.home-game-box .van-grid-item__content {
  background-color: rgb(0, 0, 0, 0) !important;
}
</style>
<style lang="scss" scoped>
.jiangjinchi {
  position: absolute;
  right: 15px;
  top: 0px;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-image: url('/static/image/user/jackpotBg.webp');
  background-repeat: no-repeat;
  background-size: 100%;
  width: 250px;
}
.swiper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.game-list .ul-auto-wrap ul li {
  margin-top: 14px;
}
.game-list .baccarat-list {
  position: relative;
  padding: 15px 13px 0px 0;
}
.banner-block[data-v-3174463f] {
  position: relative;
  min-height: 58px;
}
.game-list .baccarat-list .dew-figure-wrapper {
  min-height: 58px;
}
.other-games[data-v-5648ec66] {
  display: block;
  padding: 15px 15px 0px 15px;
  /* margin-bottom: 15px; */
}
.home-page .main .block .list .auto-wrap ul li .act img[data-v-e928e504] {
  width: 151px;
  height: 90px;
}
.game-list .ul-auto-wrap ul li {
  width: 45% !important;
  min-width: auto !important;
  min-height: 80px !important;
  height: auto !important;
  margin-right: 10px !important;
}

.ac {
  color: #fff !important;
  background: linear-gradient(#cca352, #cbb788);
  height: 30px;
  line-height: 30px;
  padding: 0px 15px;
  border-radius: 16px;
  margin-top: -3px;
}
.noac {
  border: 1px solid #eee;
  height: 30px;
  line-height: 30px;
  padding: 0px 15px;
  border-radius: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/main/index.vue